import { TimeFrame } from '../../../../types/Bot';
import { Bot } from '../../types';

export const intervalByTimeFrame: Record<TimeFrame, number> = {
  [TimeFrame.TwoMonths]: 1000 * 60 * 60 * 24 * 7 * 4 * 2,
  [TimeFrame.OneMonth]: 1000 * 60 * 60 * 24 * 7 * 4,
  [TimeFrame.ThreeWeeks]: 1000 * 60 * 60 * 24 * 7 * 3,
  [TimeFrame.TwoWeeks]: 1000 * 60 * 60 * 24 * 7 * 2,
  [TimeFrame.OneAndHalfWeek]: 1000 * 60 * 60 * 24 * 10.5,
  [TimeFrame.OneWeek]: 1000 * 60 * 60 * 24 * 7,
  [TimeFrame.HalfWeek]: 1000 * 60 * 60 * 24 * 3.5,
  [TimeFrame.TenDays]: 1000 * 60 * 60 * 24 * 10,
  [TimeFrame.SixDays]: 1000 * 60 * 60 * 24 * 6,
  [TimeFrame.FiveDays]: 1000 * 60 * 60 * 24 * 5,
  [TimeFrame.FourDays]: 1000 * 60 * 60 * 24 * 4,
  [TimeFrame.ThreeDays]: 1000 * 60 * 60 * 24 * 3,
  [TimeFrame.TwoDays]: 1000 * 60 * 60 * 24 * 2,
  [TimeFrame.OneDay]: 1000 * 60 * 60 * 24,
  [TimeFrame.HundredHours]: 1000 * 60 * 60 * 100,
  [TimeFrame.TwentyHours]: 1000 * 60 * 60 * 20,
  [TimeFrame.EighteenHours]: 1000 * 60 * 60 * 18,
  [TimeFrame.FifteenHours]: 1000 * 60 * 60 * 15,
  [TimeFrame.TwelveHours]: 1000 * 60 * 60 * 12,
  [TimeFrame.TenHours]: 1000 * 60 * 60 * 10,
  [TimeFrame.EightHours]: 1000 * 60 * 60 * 8,
  [TimeFrame.SixHours]: 1000 * 60 * 60 * 6,
  [TimeFrame.FiveHours]: 1000 * 60 * 60 * 5,
  [TimeFrame.FourHours]: 1000 * 60 * 60 * 4,
  [TimeFrame.ThreeHours]: 1000 * 60 * 60 * 3,
  [TimeFrame.TwoHours]: 1000 * 60 * 60 * 2,
  [TimeFrame.OneHour]: 1000 * 60 * 60,
  [TimeFrame.HundredMinutes]: 1000 * 60 * 100,
  [TimeFrame.SeventyFiveMinutes]: 1000 * 60 * 75,
  [TimeFrame.FiftyMinutes]: 1000 * 60 * 50,
  [TimeFrame.FortyMinutes]: 1000 * 60 * 40,
  [TimeFrame.ThirtyMinutes]: 1000 * 60 * 30,
  [TimeFrame.TwentyMinutes]: 1000 * 60 * 20,
  [TimeFrame.FifteenMinutes]: 1000 * 60 * 15,
  [TimeFrame.TenMinutes]: 1000 * 60 * 10,
  [TimeFrame.EightMinutes]: 1000 * 60 * 8,
  [TimeFrame.SixMinutes]: 1000 * 60 * 6,
  [TimeFrame.FiveMinutes]: 1000 * 60 * 5,
  [TimeFrame.FourMinutes]: 1000 * 60 * 4,
  [TimeFrame.ThreeMinutes]: 1000 * 60 * 3,
  [TimeFrame.TwoMinutes]: 1000 * 60 * 2,
  [TimeFrame.OneMinute]: 1000 * 60,
  // New for TPTs
  [TimeFrame.HundredSixtyHours]: 1000 * 60 * 60 * 160,
  [TimeFrame.HundredFiftySixHours]: 1000 * 60 * 60 * 156,
  [TimeFrame.HundredFiftyTwoHours]: 1000 * 60 * 60 * 152,
  [TimeFrame.HundredFiftyHours]: 1000 * 60 * 60 * 150,
  [TimeFrame.HundredFortySixHours]: 1000 * 60 * 60 * 146,
  [TimeFrame.HundredFortyFourHours]: 1000 * 60 * 60 * 144,
  [TimeFrame.HundredThirtySixHours]: 1000 * 60 * 60 * 136,
  [TimeFrame.HundredThirtyFourHours]: 1000 * 60 * 60 * 134,
  [TimeFrame.HundredThirtyTwoHours]: 1000 * 60 * 60 * 132,
  [TimeFrame.HundredThirtyHours]: 1000 * 60 * 60 * 130,
  [TimeFrame.HundredTwentyEightHours]: 1000 * 60 * 60 * 128,
  [TimeFrame.HundredTwentySixHours]: 1000 * 60 * 60 * 126,
  [TimeFrame.HundredFourteenHours]: 1000 * 60 * 60 * 114,
  [TimeFrame.HundredTwelveHours]: 1000 * 60 * 60 * 112,
  [TimeFrame.HundredTenHours]: 1000 * 60 * 60 * 110,
  [TimeFrame.HundredEightHours]: 1000 * 60 * 60 * 108,
  [TimeFrame.HundredSixHours]: 1000 * 60 * 60 * 106,
  [TimeFrame.NinetyTwoHours]: 1000 * 60 * 60 * 92,
  [TimeFrame.NinetyHours]: 1000 * 60 * 60 * 90,
  [TimeFrame.EightyEightHours]: 1000 * 60 * 60 * 88,
  [TimeFrame.EightySixHours]: 1000 * 60 * 60 * 86,
  [TimeFrame.EightyFourHours]: 1000 * 60 * 60 * 84,
  [TimeFrame.EightyHours]: 1000 * 60 * 60 * 80,
  [TimeFrame.SeventyEightHours]: 1000 * 60 * 60 * 78,
  [TimeFrame.SeventySixHours]: 1000 * 60 * 60 * 76,
  [TimeFrame.SeventyFiveHours]: 1000 * 60 * 60 * 75,
  [TimeFrame.SeventyThreeHours]: 1000 * 60 * 60 * 73,
  [TimeFrame.SeventyTwoHours]: 1000 * 60 * 60 * 72,
  [TimeFrame.SixtyEightHours]: 1000 * 60 * 60 * 68,
  [TimeFrame.SixtySixHours]: 1000 * 60 * 60 * 66,
  [TimeFrame.SixtyFiveHours]: 1000 * 60 * 60 * 65,
  [TimeFrame.SixtyThreeHours]: 1000 * 60 * 60 * 63,
  [TimeFrame.SixtyHours]: 1000 * 60 * 60 * 60,
  [TimeFrame.FiftyEightHours]: 1000 * 60 * 60 * 58,
  [TimeFrame.FiftySevenHours]: 1000 * 60 * 60 * 57,
  [TimeFrame.FiftySixHours]: 1000 * 60 * 60 * 56,
  [TimeFrame.FiftyFiveHours]: 1000 * 60 * 60 * 55,
  [TimeFrame.FiftyFourHours]: 1000 * 60 * 60 * 54,
  [TimeFrame.FiftyThreeHours]: 1000 * 60 * 60 * 53,
  [TimeFrame.FiftyTwoHours]: 1000 * 60 * 60 * 52,
  [TimeFrame.FiftyHours]: 1000 * 60 * 60 * 50,
  [TimeFrame.FortySixHours]: 1000 * 60 * 60 * 46,
  [TimeFrame.FortyFiveHours]: 1000 * 60 * 60 * 45,
  [TimeFrame.FortyFourHours]: 1000 * 60 * 60 * 44,
  [TimeFrame.FortyThreeHours]: 1000 * 60 * 60 * 43,
  [TimeFrame.FortyTwoHours]: 1000 * 60 * 60 * 42,
  [TimeFrame.FortyHours]: 1000 * 60 * 60 * 40,
  [TimeFrame.ThirtyEightHours]: 1000 * 60 * 60 * 38,
  [TimeFrame.ThirtySixHours]: 1000 * 60 * 60 * 36,
  [TimeFrame.ThirtyHours]: 1000 * 60 * 60 * 30,
  [TimeFrame.TwentyNineHours]: 1000 * 60 * 60 * 29,
  [TimeFrame.TwentyEightHours]: 1000 * 60 * 60 * 28,
  [TimeFrame.TwentySevenHours]: 1000 * 60 * 60 * 27,
  [TimeFrame.TwentySixHours]: 1000 * 60 * 60 * 26,
  [TimeFrame.TwentyThreeHours]: 1000 * 60 * 60 * 23,
  [TimeFrame.TwentyTwoHours]: 1000 * 60 * 60 * 22,
  [TimeFrame.TwentyOneHours]: 1000 * 60 * 60 * 21,
  [TimeFrame.NineteenHours]: 1000 * 60 * 60 * 19,
  [TimeFrame.FourteenHours]: 1000 * 60 * 60 * 14,
  [TimeFrame.ElevenHours]: 1000 * 60 * 60 * 11,
  [TimeFrame.NineHours]: 1000 * 60 * 60 * 9,
  [TimeFrame.SevenHours]: 1000 * 60 * 60 * 7,
};

/* ======================================   getTimeFrameIntervalTimestamp   ====================================== */
export const getTimeFrameIntervalTimestamp = (timeFrame: TimeFrame) => {
  return intervalByTimeFrame[timeFrame];
};

export const calculateStartTimestampByTimeFrame = (
  timeFrame: TimeFrame | undefined,
) => {
  if (!timeFrame) {
    return new Date('2022').valueOf();
  }

  return new Date().valueOf() - 100 * getTimeFrameIntervalTimestamp(timeFrame);
};

export const getMinimumZoomByTimeFrame = (timeFrame: TimeFrame | undefined) => {
  switch (timeFrame) {
    case TimeFrame.OneWeek:
      return 8500000000;

    case TimeFrame.OneDay:
      return 8500000000 / 2;

    case TimeFrame.FourHours:
      return 8500000000 / 6;

    default:
      return 8500000000;
  }
};

export const getSelectedTimeFrame = (
  bot: Bot,
  selectedTimeFrameIndex: number,
) => {
  if (!bot.timeFrame) {
    return TimeFrame.OneWeek;
  }

  switch (selectedTimeFrameIndex) {
    case 0:
      return bot?.timeFrame.multiOrder;

    case 1:
      return bot?.timeFrame.shorter;

    case 2:
      return bot?.timeFrame.higher;
    default:
      return TimeFrame.OneWeek;
  }
};
